import {
  createQueryKeyStore,
  inferQueryKeyStore,
} from "@lukemorales/query-key-factory"
import { apiClient } from "./client"

export const MsGraphQueries = createQueryKeyStore({
  account: {
    me: () => ({
      queryKey: ["me"],
      queryFn: () => apiClient.get("me"),
    }),
  },
})

export type MsGraphQueryKeys = inferQueryKeyStore<typeof MsGraphQueries>
